import { 
  Facebook, 
  Instagram, 
  Youtube, 
  Linkedin,
} from "lucide-react";
import { FaXTwitter } from "react-icons/fa6";
import TruthSocialIcon from "../../icons/truthsocial.svg";

const socialLinks = [
  { id: 1, name: "Facebook", icon: Facebook, url: "https://www.facebook.com/profile.php?id=61572001864009&mibextid=wwXIfr", hoverColor: "hover:text-[#1877F2]" },
  { id: 3, name: "Instagram", icon: Instagram, url: "https://www.instagram.com/allanimalapp?igsh=MWJyaHNoNmxjbm44ZQ%3D%3D&utm_source=qr", hoverColor: "hover:text-[#C13584]" },
  { id: 2, name: "X.com", icon: FaXTwitter, url: "https://twitter.com/AllAnimalApp", hoverColor: "hover:text-foreground" },
  {
    id: 4,
    name: "Truth Social",
    icon: null,
    customIcon: TruthSocialIcon,
    url: "https://truthsocial.com/@allanimalapp",
    hoverColor: ""
  },
  { id: 5, name: "YouTube", icon: Youtube, url: "https://youtube.com/@allanimalapp ", hoverColor: "hover:text-[#FF0000]" },
  { id: 6, name: "LinkedIn", icon: Linkedin, url: "https://www.linkedin.com/company/all-animal-app/", hoverColor: "hover:text-[#0A66C2]" },
];

const SocialMediaLinks = ({ variant = "default" }) => {
  const isProfile = variant === "profile";
  
  return (
    <div
      className={
        isProfile
          ? "flex flex-wrap justify-center items-center gap-2 sm:gap-3 w-full"
          : "fixed bottom-20 left-2 flex flex-col gap-3 z-50 p-2 rounded-lg backdrop-blur-md border border-white/20 bg-white/10"
      }
    >
      {socialLinks.map((link) => {
        const Icon = link.icon;
        return (
          <div key={link.id} className="relative group">
            <a
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.name}
              className={`
                w-10 h-10 sm:w-11 sm:h-11 
                rounded-full
                bg-[#627c75]/20 hover:bg-[#627c75]/30
                flex items-center justify-center
                text-foreground
                transition-all duration-300
                ${link.hoverColor}
                hover:scale-105
                active:scale-95
              `}
              >
              {link.customIcon ? (
                <img 
                  src={link.customIcon} 
                  alt={link.name} 
                  className="w-4 h-4 sm:w-5 sm:h-5 transition-transform duration-300"
                />
              ) : (
                <Icon className="w-4 h-4 sm:w-5 sm:h-5" />
              )}
            </a>
            
            {/* Tooltip */}
            <span className="
              absolute left-1/2 -translate-x-1/2 -top-9
              bg-foreground text-background
              px-2 py-1
              rounded-md
              text-xs
              whitespace-nowrap
              opacity-0 pointer-events-none
              group-hover:opacity-100
              transition-opacity duration-200
              z-10
            ">
              {link.name}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default SocialMediaLinks;
